"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var TokensPanel_1 = require("./TokensPanel/TokensPanel");
var TokenLoadingSpinner_1 = require("Project/Actions/Tokens/Common/TokenLoadingSpinner");
var AccountIntegrationsDataStore_1 = require("DataStores/Account/AccountIntegrationsDataStore");
var TokensPanelController = (function (_super) {
    __extends(TokensPanelController, _super);
    function TokensPanelController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokensPanelController.prototype.componentDidMount = function () {
        this.accountIntegrationsDataStore.loadTokenIntegrationsIfNeeded();
    };
    TokensPanelController.prototype.render = function () {
        return react_1.default.createElement(kaleidoscope_1.Panel, { className: "tokens-panel" }, this.renderPanelContent());
    };
    TokensPanelController.prototype.renderPanelContent = function () {
        var _a = this.props, tokenViewStore = _a.tokenViewStore, dragStore = _a.dragStore, usingFeature = _a.usingFeature, isUserAdmin = _a.isUserAdmin, projectStore = _a.projectStore, tokenReplacementStore = _a.tokenReplacementStore, tokenStore = _a.tokenStore, telemetry = _a.telemetry, modal = _a.modal;
        switch (this.accountIntegrationsDataStore.tokenIntegrations.status) {
            case FetchUtils_1.RemoteDataStatus.NotRequested:
            case FetchUtils_1.RemoteDataStatus.Loading:
                return (react_1.default.createElement("div", { className: "tokens-panel__loading" },
                    react_1.default.createElement(TokenLoadingSpinner_1.TokenLoadingSpinner, null)));
            case FetchUtils_1.RemoteDataStatus.Error:
                return (react_1.default.createElement("div", { className: "tokens-panel__error-message" }, this.accountIntegrationsDataStore.tokenIntegrations.error.message));
            case FetchUtils_1.RemoteDataStatus.Success:
                return (react_1.default.createElement(TokensPanel_1.TokensPanel, { projectStore: projectStore, tokenViewStore: tokenViewStore, dragStore: dragStore, usingFeature: usingFeature, isUserAdmin: isUserAdmin, tokenReplacementStore: tokenReplacementStore, tokenIntegrations: this.accountIntegrationsDataStore.tokenIntegrations.data, tokenStore: tokenStore, telemetry: telemetry, modal: modal }));
            default:
                throw new Error("Unhandled RemoteDataStatus");
        }
    };
    var _a;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof AccountIntegrationsDataStore_1.AccountIntegrationsDataStore !== "undefined" && AccountIntegrationsDataStore_1.AccountIntegrationsDataStore) === "function" ? _a : Object)
    ], TokensPanelController.prototype, "accountIntegrationsDataStore", void 0);
    TokensPanelController = __decorate([
        mobx_react_1.observer
    ], TokensPanelController);
    return TokensPanelController;
}(react_1.default.Component));
exports.default = TokensPanelController;
